"use strict";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PropTypes = require('prop-types');

var React = require('react');

var compose = require('../../hoc/compose');

var Toggle = require('../toggle');

var _Symbol = require('../checkboxSymbol.svg.js');

var textTypes = require('../textTypes');

var displayNames = require('../displayNames');

var Checkbox = function Checkbox(props) {
  var label = props.label,
      labelAfterSymbol = props.labelAfterSymbol,
      children = props.children,
      translateIfNeeded = props.translateIfNeeded,
      getClassName = props.getClassName,
      type = props.type;
  return /*#__PURE__*/React.createElement(Toggle, _extends({}, props, {
    name: "checkbox",
    className: getClassName('control-checkbox')
  }), label && !labelAfterSymbol ? /*#__PURE__*/React.createElement("span", {
    className: "label label-checkbox",
    key: "label"
  }, translateIfNeeded(label)) : null, /*#__PURE__*/React.createElement("span", {
    className: "symbol symbol-checkbox"
  }, /*#__PURE__*/React.createElement(_Symbol, null)), label && labelAfterSymbol ? /*#__PURE__*/React.createElement("span", {
    className: ['label', 'label-checkbox', type.toLowerCase()].join(' '),
    key: "label"
  }, translateIfNeeded(label)) : null, children);
};

Checkbox.displayName = displayNames.CHECKBOX;
Checkbox.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(textTypes.TYPES),
  labelAfterSymbol: PropTypes.bool
};
Checkbox.defaultProps = {
  type: textTypes.CHECKBOX_LABEL_DEFAULT_TYPE,
  labelAfterSymbol: false
};
module.exports = compose(Checkbox);